import { fromJS } from 'immutable'
import {
  CONSENT_MANAGEMENT_GET_REQUEST,
  CONSENT_MANAGEMENT_GET_SUCCESS,
  CONSENT_MANAGEMENT_GET_FAILURE,
  CONSENT_MANAGEMENT_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONSENT_MANAGEMENT_GET_REQUEST:
      return state
        .set('isFetching', true)
    case CONSENT_MANAGEMENT_GET_SUCCESS:
      return state
        .set('consent', fromJS(action.payload.consent))
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_GET_RESET:
      return state
        .delete('consent')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consent-management/consent-management-get-reducer.js